import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList } from "../../entities/Constants";
import { Checkbox } from "primereact/checkbox";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from "primereact/inputtextarea";

interface State {
  showConfirmationDialog: boolean;
  removeIndex: number;
}

interface Props {
  ele: FormSectionElements;
  dialogVisible: boolean;
  isEng: boolean;
  callback: any;
}

export class DialogforTableMoreButton extends React.Component<Props, State> {
  dateTypeFieldList = [];

  constructor(props: Props) {
    super(props);
    this.state = {
      showConfirmationDialog: false,
      removeIndex: -1,
    };
  }

  generateHtmlString = () => {
    if (this.props.ele.parent == null) {
      return null;
    }

    let parentEle = this.props.ele.parent as FormSubSections;
    this.dateTypeFieldList = parentEle.ListOfFormSectionElements?.filter(
      (p) => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence
    );

    let html = [];
    html.push(
      <>
        {/* @ts-ignore */}
        <Dialog
          header={this.props.isEng ? "Field options for " + this.props.ele.ENUTitle : "Field options for " + this.props.ele.FRATitle}
          footer={this.renderFooter()}
          visible={this.props.dialogVisible}
          style={{ width: '50vw' }}
          onHide={() => this.props.callback(false)}
        >
          {this.renderOptions()}
          {this.otherDataTypeFields()}
        </Dialog>
      </>
    );
    return html;
  }

  renderOptions = () => {
    let htmlString = [];

    htmlString.push(
      <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_table_editable" + this.props.ele.Id}>
        <div style={{width:'25%'}}><label htmlFor={'Update_table_input_editable' + this.props.ele.Id}>&nbsp;Update Binding Field&nbsp;</label></div>
        <div style={{width:'60%'}}><InputText id={'Update_table_input_editable' + this.props.ele.Id} className="ontario-input" value={this.props.ele.UpdateField}
          onChange={(e) => { this.props.ele.UpdateField = e.target.value; this.props.callback() }}>
        </InputText></div>

      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_table_editable" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'input_editable' + this.props.ele.ENUTitle} >&nbsp;Column Width&nbsp;</label>
        </div>
        <div style={{width:'60%'}}><InputText id={'input_editable' + this.props.ele.ENUTitle} className="ontario-input" value={this.props.ele.colWidth}
          onChange={(e) => { this.props.ele.colWidth = e.target.value;  this.props.callback() }}>
        </InputText></div>

      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', paddingTop: '10px' }} key={"chk_table_optional_" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'chk_required_' + this.props.ele.Id} style={{ marginRight: '22px' }}>&nbsp;Required&nbsp;</label>
        </div>
        <div>
          {/* @ts-ignore */}
          <Checkbox id={'chk_required_' + this.props.ele.Id} checked={this.props.ele.Optional === 'N'} onChange={(e) => { e.checked ? this.props.ele.Optional = 'N' : this.props.ele.Optional = 'Y'; this.props.callback() }} />
        </div>
      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', paddingTop: '10px' }} key={"chk_table_editable" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'chk_ReadOnly_editable' + this.props.ele.Id} style={{ marginRight: '12px' }}>&nbsp;Read Only&nbsp;</label>
        </div>
        <div>
          {/* @ts-ignore */}
          <Checkbox id={'chk_ReadOnly_editable' + this.props.ele.Id} checked={this.props.ele.Editable === 'N'} onChange={(e) => { e.checked ? this.props.ele.Editable = 'N' : this.props.ele.Editable = 'Y'; this.props.callback() }}></Checkbox>
        </div>
      </div>
    );

    htmlString.push(

    <div style={{ display: "flex", marginTop: '10px' }}>
                <div style={{ width: '25%' }}>Script</div>
                <div style={{ width: '60%'}}>                  
                <InputTextarea className="ontario-input" 
                  value={this.props.ele.Script} onChange={(e) => {
                    this.props.ele.Script = e.target.value;
                    this.props.callback();
                }}></InputTextarea></div>
            </div>
     
    );

    return htmlString;
  }

  otherDataTypeFields = () => {
    let htmlString = [];

    // Date type
    if (this.props.ele.Datatype === 'Date') {
      htmlString.push(
        <div style={{ display: "flex" }} key={'dropdown_dialog_date_ValidateCompareMethod_' + this.props.ele.Id}>
          <div style={{ width: '30%' }}>
            {/* @ts-ignore */}
            <Dropdown
              className="ontario-dropdown"
              options={dateComparisonList}
              optionLabel='label'
              optionValue='val'
              value={this.props.ele.ValidateCompareMethod}
              onChange={(e) => {
                this.props.ele.ValidateCompareMethod = e.value;
                this.props.callback();
              }}
            />
          </div>
          <div style={{ width: '70%' }} key={'dropdown_dialog_date_ValidateCompareField_' + this.props.ele.Id}>
            {/* @ts-ignore */}
            <Dropdown
              className="ontario-dropdown"
              options={this.dateTypeFieldList}
              optionLabel='ENUTitle'
              optionValue='LoadBindName'
              value={this.props.ele.ValidateCompareField}
              onChange={(e) => {
                this.props.ele.ValidateCompareField = e.value;
                this.props.callback();
              }}
            />
          </div>
        </div>
      );
    }

    // Dropdown
    if (this.props.ele.Datatype === 'Dropdown') {
      htmlString.push(this.addlov());
    }

    // Checkbox
    if (this.props.ele.Datatype === 'Checkbox') {
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '5px', paddingTop: '15px' }} key={"chk_table_optional_" + this.props.ele.Id}>
          <div>
            {/* @ts-ignore */}
            <Checkbox
              checked={this.props.ele.MustHaveTrueValueInTable === 'Y'}
              inputId={"table_chexkbox_MustHaveTrueValueInTable" + this.props.ele.Id}
              onChange={(e) => {
                if (e.checked) {
                  this.props.ele.MustHaveTrueValueInTable = 'Y';
                } else {
                  this.props.ele.MustHaveTrueValueInTable = 'N';
                }
                this.props.callback();
              }}
            />
          </div>
          <div>
            <label style={{ paddingLeft: '5px' }} htmlFor={"table_chexkbox_MustHaveTrueValueInTable" + this.props.ele.Id}>
              {"At least one '" + this.props.ele.ENUTitle + "' must be checked"}
            </label>
          </div>
        </div>
      );
    }

    return htmlString;
  }

  addlov = () => {
    let ele = this.props.ele;
    let lovString = [];
    if (ele.ListOfLOVValues == null) {
      ele.ListOfLOVValues = [];
    }

    if (ele.ListOfLOVValues.length === 0) {
      let lov=new LOVValues();
      lov.parent=ele;
      ele.ListOfLOVValues.push();
    }

    ele.ListOfLOVValues.forEach((lov: LOVValues, index) => {
      lovString.push(
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '5px', alignItems: 'center' }} key={"table_option_" + index} >
          <div style={{ marginRight: '5px' }}>{index + 1}</div>
          <div style={{ width: '70%' }}>
            <InputText
              className='ontario-input-small'
              placeholder={'Option ' + (index + 1).toString()}
              value={lov.code}
              onChange={(e) => {
                if (this.props.isEng) {
                  lov.code = e.target.value;
                  lov.description = lov.code;
                } else {
                  lov.FRA = e.target.value;
                  lov.FRADescription = e.target.value;
                }
                this.props.callback();
              }}
            ></InputText>
          </div>
          <div key={"remove_option"}>
            <i
              title="Remove me"
              className="pi pi-trash"
              style={{ fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => this.setState({ showConfirmationDialog: true, removeIndex: index })}
            ></i>
          </div>
        </div>
      );
    });

    lovString.push(
      <div key={"addoption_" + ele.Sequence}>
        <i
          style={{ border: '1px solid grey', padding: '3px 7px', borderRadius: '5px', cursor: 'pointer', marginTop: '5px' }}
          className="pi pi-plus"
          onClick={() => {
            let option = new LOVValues();
            option.parent=ele;
            option.Sequence = ele.ListOfLOVValues.length;
            ele.ListOfLOVValues.push(option);
            this.props.callback();
          }}
        ></i>
      </div>
    );

    return lovString;
  }

  renderFooter = () => {
    return (
      <div>
        {/* @ts-ignore */}
        <Button label="OK" icon="pi pi-check" onClick={() => {
          this.props.callback(false);
        }} />
        {/* @ts-ignore */}
        <Button label="Cancel" onClick={() => { this.props.callback(false) }} />
      </div>
    );
  }

  handleRemoveConfirmation = (accept: boolean) => {
    if (accept) {
      const { removeIndex } = this.state;
      const { ele, callback } = this.props;

      ele.ListOfLOVValues.splice(removeIndex, 1);
      callback();
    }

    this.setState({ showConfirmationDialog: false, removeIndex: -1 });
  };

  renderConfirmationDialog = () => {
    const { showConfirmationDialog } = this.state;

    return (
      <>
        {/* @ts-ignore */}
        <ConfirmDialog
          visible={showConfirmationDialog}
          onHide={() => this.handleRemoveConfirmation(false)}
          message="Are you sure you want to remove this?"
          header="Confirmation"
          icon="pi pi-exclamation-triangle"
          accept={() => this.handleRemoveConfirmation(true)}
          reject={() => this.setState({ showConfirmationDialog: false })}
          closable={false}
        />
      </>
    );
  };

  render() {
    return (
      <>
        {this.generateHtmlString()}
        {this.renderConfirmationDialog()}
      </>
    );
  }
}
